import lottie from "lottie-web";

class LottieHelper {
    // setup lottie animation object in container
    getLottieAnimation(svgContainer, animationJson)
    {
        let animData = {
            container: svgContainer,
            animationData: animationJson,
            renderer: 'svg',
            loop: false,
            autoplay: false,
        };

        return lottie.loadAnimation(animData);
    }
}

export default LottieHelper;



// WEBPACK FOOTER //
// ./scripts/util/lottieHelper.js